import React from "react";

const Footer: React.FC = () => {
  return (
    <div
      className="px-6 py-6 text-right"
      style={{ backgroundColor: "aliceblue" }}
    >
      <span>
        Powered by: <b>ClassBit</b>
      </span>
    </div>
  );
};

export default Footer;
